// URL de l'API backend
// Utilise le reverse proxy nginx (/api route vers http://backend:8000)
// - En Docker: appelle /api (nginx reroute)
// - En local dev: appelle http://localhost:8000 directement

const API = window.__API_URL__ || (() => {
  // En Docker (localhost !== 127.0.0.1), utilise le reverse proxy
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return '/api'; // nginx reroute vers le backend
  }
  // En local dev, appelle directement localhost:8000
  return 'http://localhost:8000';
})();

console.log(`🔧 API configured: ${API}`);

export default API;
